import React, { useContext } from 'react';
import { SchemaDisplayContext } from '../context';

function BaseNode(props) {
  const {
    positionX, positionY, width, height, children, eventHandlers, id, fake, viewBox,
  } = props;
  const { schema: { hiddenNode } } = useContext(SchemaDisplayContext);

  const display = hiddenNode && !fake && hiddenNode.node.id === id ? 'none' : 'block';

  return (
    <svg
      viewBox={viewBox}
      style={{ overflow: 'visible', display, cursor: 'pointer' }}
      x={positionX}
      y={positionY}
      width={width}
      height={height}
      {...eventHandlers}
    >
      {children}
    </svg>
  );
}

export default BaseNode;
